// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3lzTN","header":"ClearentDisclaimer_header__1oeUx","inner":"ClearentDisclaimer_inner__1YMMi"};